<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        class="ma-1 mr-10"
        fab
        top
        right
        absolute
        color="primary"
        v-on="on"
      >
        <v-icon>
          mdi-plus
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Exam"
      text="Create Exam"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              v-model="name"
              v-validate="'required|max:255'"
              :error-messages="errors.collect('name')"
              data-vv-name="name"        
              label="Name"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="passing_score"
              v-validate="'required|max:100|min:0'"
              :error-messages="errors.collect('passing score')"
              data-vv-name="passing score"        
              type="number"
              label="Passing Score"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="duration"
              v-validate="'required|min:1'"
              :error-messages="errors.collect('duration')"
              data-vv-name="duration"        
              type="number"
              label="Duration (minutes)"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="max_attempt"
              v-validate="'required|min:1'"
              :error-messages="errors.collect('max_attempt')"
              data-vv-name="max attempt"        
              type="number"
              label="Max Attempt"
            />
          </v-col>
          <v-col cols="6">
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="true"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startDate"
                  v-validate="'required'"
                  label="Exam Start Date"
                  prepend-icon="event"
                  :error-messages="errors.collect('start_date')"
                  data-vv-name="start_date"  
                  data-vv-as="start date"      
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="startDate"
              />
            </v-menu>
          </v-col>
          <v-col cols="6">
            <v-menu
              v-model="startTimeMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startTimeDisplay"
                  :rules="rules"
                  label="Exam Start Time"
                  prepend-icon="mdi-clock"
                  readonly
                  v-on="on"
                />
              </template>

              <v-time-picker
                ref="picker"
                v-model="startTime"
                :landscape="true"
                width="190"
                scrollable
                @click:minute="startTimeMenu = false"
              />
            </v-menu>
          </v-col>
          <v-col cols="6">
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="true"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endDate"
                  v-validate="'required'"
                  label="Exam End Date"
                  prepend-icon="event"
                  :error-messages="errors.collect('end_date')"
                  data-vv-name="end_date"  
                  data-vv-as="end date"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="endDate"
              />
            </v-menu>
          </v-col> 
          <v-col cols="6">
            <v-menu
              v-model="endTimeMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endTimeDisplay"
                  :rules="rules"
                  label="Exam End Time"
                  prepend-icon="mdi-clock"
                  readonly
                  v-on="on"
                />
              </template>
              <v-time-picker
                ref="picker"
                v-model="endTime"
                :landscape="true"
                width="190"
                scrollable
                @click:minute="endTimeMenu = false"
              />
            </v-menu>
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>  
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="closeDialog()"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      courseId: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        name: null,
        passing_score: null,
        duration: null,
        max_attempt: null,
        startDateMenu: false,
        startDate: null,
        startTimeMenu: false,
        startTime: null,
        endDateMenu: false,
        endDate: null,
        endTimeMenu: false,
        endTime: null,
        rules: [
          value => !!value || 'Required.',
        ],
      }
    },
    computed: {
      startTimeDisplay () {
        return this.startTime ? this.formatTime(this.startTime) : ''
      },
      endTimeDisplay () {
        return this.endTime ? this.formatTime(this.endTime) : ''
      },
    },

    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.exams().create(this.courseId, this.prepareFormData())
              .then(res => {
                this.$emit('created')
                this.$snack({ message: 'Exam created successfully' })
                this.clearForm()
                this.dialog = false
              })
              .catch(() => {
                this.$snack({ 
                  color: 'error',
                  message: 'Failed to create exam', 
                })
              })
              .then(() => {
                this.progressing = false
              })
          })
      },

      formatTime (time) {
        let a = time.split(':') // split it at the colons
        let seconds = (a[0] * 60 * 60) + (a[1] * 60)

        return this.$moment(new Date(1970, 0, 1).setSeconds(seconds)).format('hh:mm A')
      },

      prepareFormData () {
        return {
          'name': this.name,
          'passing_score': this.passing_score,
          'duration': this.duration,
          'max_attempt': this.max_attempt,
          'start_date': this.startDate + ' ' + this.startTime + ':00',
          'end_date': this.endDate + ' ' + this.endTime + ':00',
        }
      },

      closeDialog () {
        this.clearForm()
        this.dialog = false
      },

      clearForm () {
        this.name = null
        this.passing_score = null
        this.duration = null
        this.max_attempt = null
        this.startDate = null
        this.startTime = null
        this.endDate = null
        this.endTime = null
      },
    },
  }
</script>
